// extracted by mini-css-extract-plugin
export default {"container":"IssueForm_container__9zH3M","options":"IssueForm_options__bCO9+","buttons":"IssueForm_buttons__XXSyS"};